import { REST_METHOD, REST_URL } from '../constants';
import request, { RequestParams, requestIncident, requestOrder, requestPCL } from './api';
import { TicketOpenActivities } from 'models/types/TicketOpenActivities';
import { ResourceType } from 'components/MenuTicket/types';

export async function incidentResolved(params: any) {
  const { incidentId, comment, user_name } = params;
  try {
    const requestParams = {
      url: `${REST_URL.INCIDENT}${REST_URL.RESOLVED}`,
      method: `${REST_METHOD.POST}`,
      queryParams: { incident_id: incidentId, user_name: user_name },
      data: { comments: comment },
    };
    const response = await requestIncident(requestParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getListFilterINC(userName: String) {
  try {
    const requestParams = {
      url: `${REST_URL.INCIDENT}${REST_URL.GET_FILTERS}`,
      method: `${REST_METHOD.GET}`,
      queryParams: { user_name: userName },
    };
    const response = await requestIncident(requestParams);

    return response;
  } catch (error) {
    throw error;
  }
}

export async function getListFilterRITM(userName: String) {
  try {
    const requestParams = {
      url: `${REST_URL.ORDER}${REST_URL.GET_FILTERS}`,
      method: `${REST_METHOD.GET}`,
      queryParams: { user_name: userName },
    };
    const response = await requestOrder(requestParams);

    return response;
  } catch (error) {
    throw error;
  }
}

export async function getListFilterApproval(userName: String) {
  try {
    const requestParams = {
      url: `${REST_URL.APPROVAL}${REST_URL.GET_FILTERS}`,
      method: `${REST_METHOD.GET}`,
      queryParams: { user_name: userName },
    };
    const response = await requestOrder(requestParams);

    return response;
  } catch (error) {
    throw error;
  }
}

export async function getRequestTicket(param: any) {
  try {
    const {
      keyword,
      refine,
      states,
      request_for,
      sort_order,
      date_range,
      categories,
      page_size,
      page_index,
      user_name,
    } = param;
    let requestParams;
    requestParams = {
      url: `${REST_URL.ORDER}${REST_URL.SEARCH}`,
      method: `${REST_METHOD.GET}`,
      queryParams: {
        keyword,
        refine,
        states,
        request_for,
        sort_order,
        date_range,
        categories,
        page_size,
        page_index,
        user_name,
      },
    };
    return requestOrder(requestParams);
  } catch (error) {
    throw error;
  }
}

export async function getIncidentTicket(param: any) {
  try {
    const {
      keyword,
      refine,
      states,
      sort_order,
      date_range,
      page_size,
      page_index,
      user_name,
    } = param;
    let requestParams;
    requestParams = {
      url: `${REST_URL.INCIDENT}${REST_URL.SEARCH}`,
      method: `${REST_METHOD.GET}`,
      queryParams: {
        keyword,
        refine,
        states,
        sort_order,
        date_range,
        page_size,
        page_index,
        user_name,
      },
    };
    return requestIncident(requestParams);
  } catch (error) {
    throw error;
  }
}

export async function getApprovalTicket(param: any) {
  try {
    const {
      keyword,
      states,
      sort_order,
      date_range,
      page_size,
      page_index,
      user_name,
      user_sys_id,
      approver,
    } = param;
    let requestParams;
    requestParams = {
      url: `${REST_URL.APPROVAL}${REST_URL.SEARCH}`,
      method: `${REST_METHOD.GET}`,
      queryParams: {
        keyword,
        states,
        sort_order,
        date_range,
        page_size,
        page_index,
        user_name,
        user_sys_id,
        approver,
      },
    };
    return requestOrder(requestParams);
  } catch (error) {
    throw error;
  }
}
export async function getAllApprovalTicket(param: any) {
  try {
    const {
      states,
      user_name,
      user_sys_id,
      rh_user_id,
      page_index,
      date_range,
      sort_order,
      approver,
      page_size
    } = param;
    let requestParams;
    requestParams = {
      url: `${REST_URL.APPROVAL}${REST_URL.GET_ALL_APPROVAL}`,
      method: `${REST_METHOD.GET}`,
      queryParams: {
        states,
        user_name,
        user_sys_id,
        rh_user_id,
        page_index,
        date_range,
        sort_order,
        approver,
        page_size
      },
    };
    return requestOrder(requestParams);
  } catch (error) {
    throw error;
  }
}

export async function getAllRequestTicket(param: any) {
  try {
    const {
      states,
      user_name,
      delegation,
      rh_user_id,
      page_index,
      date_range,
      sort_order,
      page_size
    } = param;
    let requestParams;
    requestParams = {
      url: `${REST_URL.ORDER}${REST_URL.GET_ALL_REQUEST}`,
      method: `${REST_METHOD.GET}`,
      queryParams: {
        states,
        user_name,
        delegation,
        rh_user_id,
        page_index,
        date_range,
        sort_order,
        page_size
      },
    };
    return requestOrder(requestParams);
  } catch (error) {
    throw error;
  }
}

export async function getActivities(isTicket: string, uid: string) {
  try {
    let url =
      isTicket === 'INC'
        ? `${REST_URL.INCIDENT}${REST_URL.ACTIVITIES}`
        : `${REST_URL.REQUEST}${REST_URL.ACTIVITIES}`;
    const requestParams = {
      url: url,
      method: `${REST_METHOD.GET}`,
      queryParams: { uid: uid },
    };
    let result = isTicket === 'INC' ? await requestIncident(requestParams) : await requestOrder(requestParams);

    if (!result) {
      return;
    }

    result = result.data;
    
    return result;
  } catch (error) {
    throw error;
  }
}

export async function getTicketDetail(
  isTicket: string,
  params: {
    ticketNumber: string,
    userName: string,
  },
) {
  const { ticketNumber, userName } = params;
  try {
    let requestParams;
    isTicket === 'INC'
      ? (requestParams = {
          url: `${REST_URL.INCIDENT}${REST_URL.GET_INCIDENT_NUMBER}`,
          method: `${REST_METHOD.GET}`,
          queryParams: {
            incident_number: ticketNumber,
            user_name: userName,
          },
        })
      : (requestParams = {
          url: `${REST_URL.ORDER}${REST_URL.GET_INCIDENT_NUMBER}`,
          method: `${REST_METHOD.GET}`,
          queryParams: {
            order_number: ticketNumber,
            user_name: userName,
          },
        });

    let result = isTicket === 'INC' ? await requestIncident(requestParams) : await requestOrder(requestParams);

    return result;
  } catch (error) {
    throw error;
  }
}

export async function getApprovalDetail(params: any) {
  const { uid, user_name, user_sys_id } = params;
  try {
    const requestParams = {
      url: `${REST_URL.APPROVAL}${REST_URL.RETRIEVE}`,
      method: `${REST_METHOD.GET}`,
      queryParams: {
        uid,
        user_name,
        user_sys_id,
      },
    }

    let result = await requestOrder(requestParams);

    return result;
  } catch (error) {
    throw error;
  }
}

export async function searchIncidentTicket(param: any) {
  const {
    keyword,
    page_size,
    page_index,
    user_name,
    states,
    date_range,
  } = param;
  let requestParams;
  requestParams = {
    url: `${REST_URL.INCIDENT}${REST_URL.SEARCH}`,
    method: `${REST_METHOD.GET}`,
    queryParams: {
      keyword,
      page_size,
      page_index,
      user_name,
      states,
      date_range,
    },
  };
  return requestIncident(requestParams);
}

export async function searchRequestTicket(param: any) {
  const {
    keyword,
    page_size,
    page_index,
    user_name,
    states,
    date_range,
  } = param;
  let requestParams;
  requestParams = {
    url: `${REST_URL.ORDER}${REST_URL.SEARCH}`,
    method: `${REST_METHOD.GET}`,
    queryParams: {
      keyword,
      page_size,
      page_index,
      user_name,
      states,
      date_range,
    },
  };
  return requestOrder(requestParams);
}

export async function searchApprovalTicket(param: any) {
  const {
    keyword,
    page_size,
    page_index,
    user_name,
    user_sys_id,
    states,
    date_range,
    approver,
  } = param;
  let requestParams;
  requestParams = {
    url: `${REST_URL.APPROVAL}${REST_URL.SEARCH}`,
    method: `${REST_METHOD.GET}`,
    queryParams: {
      keyword,
      page_size,
      page_index,
      user_name,
      user_sys_id,
      states,
      date_range,
      approver,
    },
  };
  return requestOrder(requestParams);
}

const TicketServices = {
  incidentResolved:incidentResolved,
  getAttachmentsTicket: async (param: any, uidApproval: any, isIncident: boolean) => {
    const markTypeAttachment = (response: any, type: string) => {
      if (!response || response?.status !== 200) return;
      response?.data?.forEach((item: any) => {
        type === ResourceType.Approvals? item.isApproval = true : item.isRequest = true;
      });
      return {...response, data: response?.data};
    };
    try {
      let requestParams = {};
      let requestParamsRequest = {};
      let requestParamsApproval: any = {};
      let responseApproval: any = null;
      let responseRequest = null;
      let result = null;
      let response = null;
      
      if (isIncident) {
        requestParams = {
          url: `${REST_URL.INCIDENT}${REST_URL.GET_ATTACHMENTS}`,
          method: `${REST_METHOD.GET}`,
          queryParams: {
            incident_id: param,
          },
        };
      } else  {
        requestParamsRequest = {
          url: `${REST_URL.ORDER}${REST_URL.GET_ATTACHMENTS}`,
          method: `${REST_METHOD.GET}`,
          queryParams: {
            uid: param,
          },
        };
        (uidApproval?.length !== 0 && uidApproval !== undefined) && 
          (requestParamsApproval = uidApproval?.length >= 1 && Array.isArray(uidApproval) ? (
            uidApproval?.map((item: any) => {
              return {
                url: `${REST_URL.APPROVAL}${REST_URL.GET_ATTACHMENTS}`,
                method: `${REST_METHOD.GET}`,
                queryParams: {
                  uid: item?.uid,
                },
              }
            })
          ) : 
            {
              url: `${REST_URL.APPROVAL}${REST_URL.GET_ATTACHMENTS}`,
              method: `${REST_METHOD.GET}`,
              queryParams: {
                uid: uidApproval,
              },
            }
          );
      };

      if(isIncident) {
        response = await requestIncident(requestParams as RequestParams);
        return response.data || {};
      } else {
        let attachmentsApprover: any[] = [];
        if(uidApproval?.length !== 0 && uidApproval !== undefined) {
          if(requestParamsApproval.length >= 1) {
            for (const item of requestParamsApproval) {
              responseApproval = markTypeAttachment(await requestOrder(item as RequestParams), ResourceType.Approvals);
              attachmentsApprover?.push(...responseApproval?.data);
            }
          } else {
            responseApproval = markTypeAttachment(await requestOrder(requestParamsApproval as RequestParams), ResourceType.Approvals);
            attachmentsApprover = responseApproval?.data || [];
          };         
        };

        responseRequest = markTypeAttachment(await requestOrder(requestParamsRequest as RequestParams), ResourceType.Requests);
        result = attachmentsApprover?.concat(responseRequest?.data);
        return result || {};
      }
    } catch (error) {
      throw error;
    }
  },
  postAttachmentsIncident: async (params: any, formData: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.INCIDENT}${REST_URL.POST_ATTACHMENT}`,
        method: `${REST_METHOD.POST}`,
        queryParams: {
          incident_id: params.id,
          file_name: params.name,
          type: params.type,
        },
        options: {
          'Content-Type': 'application/octet-stream',
        },
        data: formData,
      };
      const response = await requestIncident(requestParams);
      return response || {};
    } catch (error) {
      throw error;
    }
  },

  postAttachmentsRequest: async (params: any, formData: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.ORDER}${REST_URL.POST_ATTACHMENT}`,
        method: `${REST_METHOD.POST}`,
        queryParams: {
          RITM_sys_id: params.id,
          file_name: params.name,
          type: params.type,
        },
        options: {
          'Content-Type': 'application/octet-stream',
        },
        data: formData,
      };
      const response = await requestOrder(requestParams);
      return response || {};
    } catch (error) {
      throw error;
    }
  },

  downloatAttachmentBySysId: async (params: any) => {
    try {
      const requestParams: RequestParams = {
        url: `${REST_URL.INCIDENT}${REST_URL.DOWNLOAD_ATTACHMENT}/${params}${REST_URL.FILE}`,
        method: `${REST_METHOD.GET}`,
        responseType: 'blob',
      };

      const response = await requestIncident(requestParams);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  incidentReopen: async (param: any, comments: string) => {
    try {
      const {incident_id, user_name} = param;
      const requestParams = {
        url: `${REST_URL.INCIDENT}${REST_URL.POST_INCIDENT_REOPEN}`,
        method: `${REST_METHOD.POST}`,
        queryParams: {
          incident_id: incident_id,
          user_name: user_name,
        },
        data: { comments: comments },
      };
      const response = await requestIncident(requestParams);
      return response.data || {};
    } catch (error) {
      throw error;
    }
  },

  approvalApproved: async (param: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.APPROVAL}${REST_URL.APPROVE}`,
        method: `${REST_METHOD.POST}`,
        queryParams: {
          uid: param.approvalId,
          user_sys_id: param.user_sys_id,
        },
        data: { comments: param.comments },
      };
      const response = await requestOrder(requestParams);
      return response.data || {};
    } catch (error) {
      throw error;
    }
  },

  approvalRejected: async (param: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.APPROVAL}${REST_URL.REJECT}`,
        method: `${REST_METHOD.POST}`,
        queryParams: {
          uid: param.approvalId,
          user_sys_id: param.user_sys_id,
        },
        data: { comments: param.comments },
      };
      const response = await requestOrder(requestParams);
      return response.data || {};
    } catch (error) {
      throw error;
    }
  },

  provideComment: async (
    isTicket: string,
    id: string,
    userName: string,
    comments: string,
    activeTab: string,
  ) => {
    try {
      let requestParams;
      isTicket === 'INC'
        ? (requestParams = {
            url: `${REST_URL.INCIDENT}${REST_URL.ADD_COMMENT}`,
            method: `${REST_METHOD.POST}`,
            queryParams: {
              incident_id: id,
              ...(userName && { user_name: userName }),
            },
            data: {
              comments: comments,
            },
          })
          : activeTab !== ResourceType.Approvals ? (requestParams = {
            url: `${REST_URL.ORDER}${REST_URL.ADD_COMMENT}`,
            method: `${REST_METHOD.POST}`,
            queryParams: {
              uid: id,
            },
            data: {
              comments: comments,
            },
          }) : (requestParams = {
            url: `${REST_URL.APPROVAL}${REST_URL.ADD_COMMENT}`,
            method: `${REST_METHOD.POST}`,
            queryParams: {
              uid: id,
            },
            data: {
              comments: comments,
            },
          });
      const response = isTicket === 'INC' ? await requestIncident(requestParams) : await requestOrder(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },
  deleteAttachment: async (attachmentId: any, isIncident: boolean, isActiveTabRequests: boolean) => {
    try {
      const requestParams = {
        url: `${isIncident ? REST_URL.INCIDENT : isActiveTabRequests? REST_URL.ORDER : REST_URL.APPROVAL}${
          REST_URL.DELETE_ATTACHMENT
        }`,
        method: `${REST_METHOD.DELETE}`,
        queryParams: {
          attachment_id: attachmentId,
        },
      };
      const response = isIncident ? await requestIncident(requestParams) : await requestOrder(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },
  getCanCancelStatus: async (ticketNumber: string) => {
    try {
      const requestParams = {
        url: `${REST_URL.ORDER}${REST_URL.CHECK_CANCEL}`,
        method: `${REST_METHOD.GET}`,
        queryParams: {
          order_number: ticketNumber
        },
      }
      let response = await requestOrder(requestParams);
      response = {response};
      return response?.response?.data?.canCancel;
    } catch (error) {
      throw error;
    }
  },
  postSubmitCancellation: async (params: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.PC_LIFECYCLE_CANCEL_REQUEST}`,
        method: `${REST_METHOD.POST}`,
        data: {...params}
      }
      let response = await requestPCL(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },

  getOpenSupportActivities: async (params: TicketOpenActivities) => {
    try {
      const requestParams = {
        url: `${REST_URL.GET_OPEN_SUPPORT_ACTIVITIES}`,
        method: `${REST_METHOD.GET}`,
        queryParams: params,
      }
      const response = await request(requestParams);
      return response;
    } catch (error){
      throw error;
    }
  },

  postAttachmentApproval: async (params: any, formData: any) => {
    try {
      const requestParams = {
        url: `${REST_URL.APPROVAL}${REST_URL.POST_ATTACHMENT}`,
        method: `${REST_METHOD.POST}`,
        queryParams: {
          approval_sys_id: params.id,
          file_name: params.name,
          type: params.type,
        },
        options: {
          'Content-Type': 'application/octet-stream',
        },
        data: formData,
      };
      const response = await requestOrder(requestParams);
      return response;
    } catch (error) {
      throw error;
    }
  },
};

export default TicketServices;
